import React from 'react'
import {Icon} from '@chakra-ui/react'

const ProductCountIcon = (props) => {
    return (
        <Icon viewBox="0 0 13 13" fill="none" {...props}>
            <path
                d="M7.46689 11.7333V6.4C7.46689 6.1171 7.35451 5.84579 7.15448 5.64575C6.95444 5.44571 6.68313 5.33333 6.40023 5.33333H2.13356C1.85066 5.33333 1.57935 5.22095 1.37931 5.02091C1.17928 4.82087 1.06689 4.54956 1.06689 4.26667V2.13333C1.06689 1.85043 1.17928 1.57912 1.37931 1.37909C1.57935 1.17905 1.85066 1.06667 2.13356 1.06667H10.6669C10.9498 1.06667 11.2211 1.17905 11.4211 1.37909C11.6212 1.57912 11.7336 1.85043 11.7336 2.13333V11.7333H1.06689"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7334 5.33332L4.69336 5.33332"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.6001 11.7333V8.53333C9.6001 8.25044 9.71248 7.97913 9.91252 7.77909C10.1126 7.57905 10.3839 7.46667 10.6668 7.46667H11.7334"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.7334 5.33334V6.4"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.7333 11.7333C2.82663 11.7333 2.1333 11.04 2.1333 10.1333V8.53333H5.3333V10.1333C5.3333 11.04 4.63997 11.7333 3.7333 11.7333Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.06689 9.6C1.06689 9.3171 1.17928 9.04579 1.37931 8.84575C1.57935 8.64571 1.85066 8.53333 2.13356 8.53333"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="9.31992"
                y1="11.52"
                x2="9.31992"
                y2="1.28"
                stroke="currentColor"
                strokeWidth="1.2"
                opacity="0.1"
            />
            <path
                d="M6.56006 5.76L6.56006 1.28"
                stroke="currentColor"
                strokeWidth="1.2"
                opacity="0.1"
            />
            <path
                d="M3.83984 5.12L3.83984 1.28"
                stroke="currentColor"
                strokeWidth="1.2"
                opacity="0.1"
            />
        </Icon>
    )
}

export default ProductCountIcon
